import axios, { AxiosPromise } from 'axios';

export const getCidadeLogada = (): AxiosPromise<any> =>
  axios.get(`/api/cidades-aise/me`);
